export enum CoordinationStatusColorDroneEnum {
    COORDINATION_UNKNOWN = 'medium',
    COORDINATION_CREATED = 'success',
    COORDINATION_REMOVED = 'medium',
    COORDINATION_PENDING_ACCEPTANCE = 'maizecrayola',
    COORDINATION_PENDING_REVIEW = 'activated',
    COORDINATION_APPROVED = 'success',
    COORDINATION_COORDINATED = 'zomp',
    COORDINATION_ACTIVATED = 'pistachio',
    COORDINATION_DEACTIVATED = 'queenblue',
    COORDINATION_FINISHED = 'success',
    COORDINATION_CANCELLING = 'yelloworange',
    COORDINATION_CANCELLED = 'redsalsa',
    COORDINATION_SUSPENDING = 'maizecrayola',
    COORDINATION_SUSPENDED = 'orangered',
    COORDINATION_REJECTED = 'danger',
    COORDINATION_UNDERTEST = 'tertiary',
  }